import api from '../api/client';
// components/SummaryCards.js
// import React from 'react';
// import { Card, Col, Row } from 'react-bootstrap';
// import { formatKES } from '../utils/currency';
// import {
//     FaShoppingCart, // Sales
//     FaMoneyBillWave, // Expenses / Payments
//     FaChartLine, // Net Profit / Profit Margin
//     FaFileInvoiceDollar, // Receivables
//     FaFileInvoice, // Payables
//     FaFileAlt, // Pending Bills
//     FaClipboardList, // Pending Sales
//     FaClock, // Pending Payments
//     FaPercentage // Collection & Payment Rates
// } from 'react-icons/fa';

// const SummaryCards = ({ data, metrics }) => {
//     const cards = [
//         {
//             title: 'Total Sales',
//             value: formatKES(data?.totalSalesPaid),
//             icon: <FaShoppingCart />,
//             color: 'purple'
//         },
//         {
//             title: 'Total Expenses',
//             value: formatKES(data?.totalExpensesPaid),
//             icon: <FaMoneyBillWave />,
//             color: 'purple'
//         },
//         {
//             title: 'Net Profit',
//             value: formatKES(data?.netProfit),
//             icon: <FaChartLine />,
//             color: data?.netProfit >= 0 ? 'blue' : 'red'
//         },
//         {
//             title: 'Receivables',
//             value: formatKES(data?.totalSalesBalance),
//             icon: <FaFileInvoiceDollar />,
//             color: 'purple'
//         },
//         {
//             title: 'Payables',
//             value: formatKES(data?.totalExpensesBalance),
//             icon: <FaFileInvoice />,
//             color: 'purple'
//         },
//         {
//             title: 'Pending Bills',
//             value: data?.unpaidBills,
//             icon: <FaFileAlt />,
//             color: 'purple'
//         },
//         {
//             title: 'Pending Sales',
//             value: data?.unpaidSales,
//             icon: <FaClipboardList />,
//             color: 'purple'
//         },
//         {
//             title: 'Pending Payments',
//             value: data?.unpaidBills + data?.unpaidSales,
//             icon: <FaClock />,
//             color: 'purple'
//         },
//         {
//             title: 'Collection Rate',
//             value: `${metrics?.collectionRate?.toFixed(2)}%`,
//             icon: <FaPercentage />,
//             color: 'purple'
//         },
//         {
//             title: 'Payment Rate',
//             value: `${metrics?.paymentRate?.toFixed(2)}%`,
//             icon: <FaPercentage />,
//             color: 'purple'
//         },
//         {
//             title: 'Profit Margin',
//             value: `${metrics?.profitMargin?.toFixed(2)}%`,
//             icon: <FaChartLine />,
//             color: 'purple'
//         }
//     ];

//     return (
//         <Row className="">
//             {cards.map((card, index) => (
//                 <Col key={index} xs={12} sm={6} lg={4} xl={2}>
//                     <Card className="">
//                         <Card.Body className="d-flex align-items-center justify-content-between">
//                             <div className="f-32">{card.icon}</div>
//                             <div>
//                                 <p className="mb-1">{card.title}</p>
//                                 <h6 className="fw-bold">{card.value}</h6>
//                             </div>
//                         </Card.Body>
//                     </Card>
//                 </Col>
//             ))}
//         </Row>
//     );
// };

// export default SummaryCards;


import { Row, Col, Card, Statistic } from 'antd';
import { 
  ShoppingCartOutlined, 
  MoneyCollectOutlined, 
  RiseOutlined, 
  FileTextOutlined,
  FileDoneOutlined,
  FileSyncOutlined,
  UnorderedListOutlined,
  ClockCircleOutlined,
  PercentageOutlined,
  BarChartOutlined
} from '@ant-design/icons';
import { formatKES } from '../utils/currency';

const SummaryCards = ({ data, metrics }) => {
  const cards = [
    {
      title: 'Total Sales',
      value: data?.totalSalesPaid,
      icon: <ShoppingCartOutlined />,
      color: '#181818ff',
      precision: 0
    },
    {
      title: 'Total Expenses',
      value: data?.totalExpensesPaid,
      icon: <MoneyCollectOutlined />,
      color: '#181818ff',
      precision: 0
    },
    {
      title: 'Net Profit',
      value: data?.netProfit,
      icon: <RiseOutlined />,
      color: data?.netProfit >= 0 ? '#1890ff' : '#cf1322',
      precision: 0
    },
    {
      title: 'Receivables',
      value: data?.totalSalesBalance,
      icon: <FileTextOutlined />,
      color: '#181818ff',
      precision: 0
    },
    {
      title: 'Payables',
      value: data?.totalExpensesBalance,
      icon: <FileDoneOutlined />,
      color: '#181818ff',
      precision: 0
    },
    {
      title: 'Pending Bills',
      value: data?.unpaidBills,
      icon: <FileSyncOutlined />,
      color: '#181818ff',
      precision: 0
    },
    {
      title: 'Pending Sales',
      value: data?.unpaidSales,
      icon: <UnorderedListOutlined />,
      color: '#181818ff',
      precision: 0
    },
    {
      title: 'Pending Payments',
      value: data?.unpaidBills + data?.unpaidSales,
      icon: <ClockCircleOutlined />,
      color: '#181818ff',
      precision: 0
    },
    {
      title: 'Collection Rate',
      value: metrics?.collectionRate,
      icon: <PercentageOutlined />,
      color: '#181818ff',
      precision: 2,
      suffix: '%'
    },
    {
      title: 'Payment Rate',
      value: metrics?.paymentRate,
      icon: <PercentageOutlined />,
      color: '#181818ff',
      precision: 2,
      suffix: '%'
    },
    {
      title: 'Profit Margin',
      value: metrics?.profitMargin,
      icon: <BarChartOutlined />,
      color: '#181818ff',
      precision: 2,
      suffix: '%'
    }
  ];

  // const formatKES = (value) => {
  //   if (value === undefined || value === null) return 'KES 0';
  //   return `KES ${value.toLocaleString()}`;
  // };

  return (
    <Row gutter={[16, 16]}>
      {cards.map((card, index) => (
        <Col key={index} xs={24} sm={12} md={8} lg={6} xl={4}>
          <Card 
            bordered={false} 
            style={{ 
              borderRadius: '8px',
              boxShadow: '0 4px 8px rgba(0,0,0,0.05)',
              transition: 'all 0.3s ease'
            }}
            bodyStyle={{ padding: '16px' }}
            hoverable
          >
            <Statistic
              title={<span style={{ color: '#8c8c8c', fontSize: '14px' }}>{card.title}</span>}
              value={card.value || 0}
              precision={card.precision}
              valueStyle={{ 
                fontFamily: 'inherit',
                color: card.color,
                fontSize: '18px',
                fontWeight: 600
              }}
              prefix={card.icon}
              suffix={card.suffix || (card.title.includes('Rate') || card.title.includes('Margin') ? '' : 
                (typeof card.value === 'number' && !card.title.includes('Pending') ? '' : ''))}
              formatter={(value) => {
                if (card.title.includes('Rate') || card.title.includes('Margin')) {
                  return value?.toFixed(2);
                }
                if (card.title.includes('Pending') && !card.title.includes('Payments')) {
                  return value;
                }
                return formatKES(value);
              }}
            />
          </Card>
        </Col>
      ))}
    </Row>
  );
};

 export default SummaryCards;